import { underscored } from 'underscore.string';
import { getLaneAccessorialRatesV2 } from 'utils/AccessorialRequestWebAPIUtils';
import qs from 'qs';
import {
  getStandardAccessorials,
  getAccessorials,
} from 'utils/AccessorialWebAPIUtils';

export const createLaneAccessorialRatesPayload = ({
  customerData,
  date,
  laneAccessorialRates,
  market,
}) => {
  const accessorialRatesPayload = [];
  customerData.forEach((customer) => {
    laneAccessorialRates.forEach((accessorialRate = {}) => {
      accessorialRatesPayload.push({
        ...accessorialRate,
        customer: customer.customer,
        ...date,
        market,
        ...(!accessorialRate.hasOwnProperty('autoApply') && {
          autoApply: false,
        }),
      });
    });
  });
  return accessorialRatesPayload;
};

export const fetchAccessorials = async (options = {}) => {
  const result = await getAccessorials({
    paginate: false,
    ...options,
  });

  const {
    entity: { items },
  } = result;

  const accessorials = items.map((a) => ({
    ...a,
    slug: a.slug || underscored(a.name.toLowerCase()),
  }));
  return accessorials;
};

// the lane accessorial rates data returned from Pricing Engine includes columns from the metadata table.
// the metadata table has some lowercase and/or truncated field names (ex: 'accesscode' instead of accessorialCode)
// however, the standard rates model uses camel case and full names, i.e. 'accessorialType' and 'accessorialCode' vs 'accessorialtype' and 'accesscode'

export const fetchExistingAccessorialRates = async ({
  status,
  market,
  customer,
  customerType,
}) => {
  const query = qs.stringify({ status, market, customer, customerType });
  const response = await getLaneAccessorialRatesV2(query);
  const {
    data: { laneAccessorialRates },
  } = response;
  return laneAccessorialRates;
};

export const fetchStandardAccessorialRates = async ({
  customerType,
  market,
}) => {
  const query = qs.stringify(
    {
      customerType: customerType.toLowerCase(),
      market: [market],
      isActive: true,
      paginate: false,
    },
    { arrayFormat: 'comma' },
  );
  const response = await getStandardAccessorials(query);
  const {
    entity: {
      results: { standardAccessorialRates },
    },
  } = response;
  return mapStandardAccessorialRateFields(standardAccessorialRates);
};

const mapStandardAccessorialRateFields = (standardRates) => {
  const mappedStandardRates = [];
  if (standardRates && standardRates.length) {
    standardRates.forEach((standardRate) => {
      mappedStandardRates.push({
        accessorialtype: standardRate.accessorialType,
        accesscode: standardRate.accessorialCode,
        rate: standardRate.rate,
        ratetype: standardRate.rateType,
        units: standardRate.unit,
      });
    });
  }
  return mappedStandardRates;
};
